import { render, staticRenderFns } from "./saj-toastification.vue?vue&type=template&id=ef96b8dc&scoped=true&"
import script from "./saj-toastification.vue?vue&type=script&lang=js&"
export * from "./saj-toastification.vue?vue&type=script&lang=js&"
import style0 from "./saj-toastification.vue?vue&type=style&index=0&id=ef96b8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef96b8dc",
  null
  
)

export default component.exports